module.exports = __webpack_public_path__ + "img/hosting-pre-wp.a0d4bf91.svg";